<h1 mat-dialog-title>Link with a practice</h1>

<div mat-dialog-content>
    <p class="hint">Enter the referral code the other MedicAI practice gave you. Their administrators see it in their
        MedicAI Network settings. Nothing about your patients is shared until they accept and you refer a patient.</p>

    <mat-form-field appearance="outline" class="full-width rid-form">
        <mat-label>Referral code</mat-label>
        <input matInput [ngModel]="code" (ngModelChange)="onInput($event)" (keydown.enter)="submit()" placeholder="XXXX-XXXX-XXXX"
            autocomplete="off" spellcheck="false" maxlength="20" data-test="practice-code-input" required>
    </mat-form-field>

    <div class="rid-error" *ngIf="error" data-test="practice-link-error">
        <mat-icon>error_outline</mat-icon>
        <div>{{ error }}</div>
    </div>
</div>

<div mat-dialog-actions align="end">
    <button mat-button (click)="cancel()" [disabled]="isSaving">Cancel</button>
    <button mat-flat-button color="primary" (click)="submit()" [disabled]="!canSubmit" data-test="practice-link-submit">
        {{ isSaving ? 'Sending…' : 'Send request' }}
    </button>
</div>
